/**
 * Removes all occurrences of the word "vonq" (case-insensitive) from a string
 * and collapses any resulting double-spaces. Used to scrub third-party brand
 * names from API-sourced text before it reaches the UI.
 */
export function stripVonq(text: string | null | undefined): string {
  if (!text) return '';
  return text
    .replace(/vonq/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
